import type { IntakePaperworkCheckItem } from "./opsIntakePaperworkCheck";

const STATUS_STYLES: Record<
  IntakePaperworkCheckItem["status"],
  { dot: string; text: string }
> = {
  pass: {
    dot: "bg-emerald-500",
    text: "text-emerald-800 dark:text-emerald-200",
  },
  warn: {
    dot: "bg-amber-500",
    text: "text-amber-800 dark:text-amber-200",
  },
  fail: {
    dot: "bg-red-500",
    text: "text-red-800 dark:text-red-200",
  },
};

export function IntakePaperworkChecklist({ items }: { items: IntakePaperworkCheckItem[] }) {
  return (
    <div className="rounded-md border border-gray-200 bg-gray-50/80 px-3 py-3 dark:border-zinc-700 dark:bg-zinc-900/40">
      <h3 className="text-xs font-semibold uppercase tracking-wide text-gray-600 dark:text-zinc-400">
        Paperwork check
      </h3>
      <ul className="mt-2 space-y-2">
        {items.map((item) => {
          const style = STATUS_STYLES[item.status];
          return (
            <li key={item.id} className="flex gap-2 text-xs">
              <span
                className={`mt-1.5 h-2 w-2 shrink-0 rounded-full ${style.dot}`}
                aria-hidden
              />
              <div className={style.text}>
                <div className="font-medium">{item.label}</div>
                {item.detail ? (
                  <div className="mt-0.5 font-normal opacity-90">{item.detail}</div>
                ) : null}
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
